import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import classnames from 'classnames';
import s from './InputLabel.scss';
/**
 * Renders children in a `<label />`. This is a necessary element of all form elements.
 */ const InputLabel = (_param)=>{
    var { children, className } = _param, rest = _object_without_properties(_param, [
        "children",
        "className"
    ]);
    return /*#__PURE__*/ React.createElement("label", _object_spread({
        className: classnames(s['root'], className)
    }, rest), children);
};
InputLabel.displayName = 'InputLabel';
export default InputLabel;

//# sourceMappingURL=InputLabel.js.map